module.exports = __webpack_public_path__ + "img/3.c21becf4.png";